import React from 'react'
import NavBar from '../Navbar/NavBar'
import ContactUs from '../ContactUs/ContactUs'
import HomePage from '../HomePage/HomePage'
import AboutFounder from '../AboutFounder/AboutFounder'
import SideBar from '../SideBar/SideBar'
import ProjectCategories from '../ProjectCategories/ProjectCategories'
import { useState, useEffect } from 'react'
import { AnimatePresence } from 'framer-motion'
import { useLocation } from 'react-router-dom'
import { scroller } from 'react-scroll'
import './LandingPage.css'

const LandingPage = () => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const savedY = sessionStorage.getItem('landingScrollY');
        if (savedY !== null) {
            sessionStorage.removeItem('landingScrollY');
            requestAnimationFrame(() => {
                window.scrollTo({ top: parseInt(savedY, 10), behavior: 'instant' });
            });
        } else {
            scroller.scrollTo('home', {
                duration: 1500,
                smooth: 'easeInOutQuart',
                offset: 0
            });
        }

        return () => {
            sessionStorage.setItem('landingScrollY', String(window.scrollY));
        };
    }, []);

    const handleMenuClick = () => setMenuIsOpen(!menuIsOpen)
    const handleOptionClick = () => setMenuIsOpen(false)

    return (
        <div>
            <NavBar hamburgerClickHandler={handleMenuClick} isOpen={menuIsOpen} />
            <AnimatePresence>
                {menuIsOpen && <SideBar optionClickHandler={handleOptionClick} />}
            </AnimatePresence>
            <HomePage />
            <ProjectCategories />
            <AboutFounder />
            <ContactUs />
        </div>
    )
}

export default LandingPage
